import { render, staticRenderFns } from "./notes-table.vue?vue&type=template&id=61453e63&"
import script from "./notes-table.vue?vue&type=script&lang=js&"
export * from "./notes-table.vue?vue&type=script&lang=js&"
import style0 from "./notes-table.vue?vue&type=style&index=0&id=61453e63&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports